module.exports = __webpack_public_path__ + "assets/btn_a2hs.acc996a555caae89b78df06f9fe84b94.png";